const { useCallback } = require('react');

const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const { Button } = require('@andes/button');
const { Title } = require('@andes/typography');
const { useI18n } = require('nordic/i18n');
const Footer = require('@cow/core-components/components/Footer');
const classNames = require('classnames');

const IconBack = require('../../icons/Back');
const stepActions = require('../../../spa/actions/step');
const { getQueryParams } = require('../../../utils/Dom');
const { STEP_NEXT } = require('../../../spa/actions/types');
const { DEVICE_TYPE } = require('../../../../constants/commons');
const translate = require('../../../translation');
const { UserTypeMobile } = require('./UserTypeMobile');
const { UserTypeDesktop } = require('./UserTypeDesktop');

const ShippingUserTypeV2 = (props) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const { flow, data, history, stepAction, deviceType, configs } = props;
  const { isBPP, back_url, brand_name } = data;

  const isMobile = deviceType === DEVICE_TYPE.MOBILE;
  const hasBackToSellerAction =
    brand_name && back_url && brand_name !== '' && back_url !== '';

  const handleRedirectingToStore = () => {
    if (back_url?.length) {
      window.location.assign(back_url);
    }
  };

  const handleNextStep = useCallback(
    (id) => {
      const urlParams = getQueryParams();

      const defaultData = {
        urlParams,
        type: flow.type,
      };

      const payload = {
        isNewInterface: true,
        user_option_selected: id,
      };

      stepAction[STEP_NEXT](
        payload,
        flow.id,
        defaultData,
        flow.type,
        urlParams,
        history,
      );
    },
    [flow, history],
  );

  return (
    <>
      <section className="shipping-user-type-v2 shipping-generics">
        <Title
          size="s"
          className={classNames('mt-40i mb-32i a', {
            'text-center': isMobile,
          })}
          component="div"
        >
          {translations.CHOOSE_HOW_YOU_WANT_TO_PAY_AND_RECEIVE_YOUR_PURCHASE}
        </Title>
        {isMobile ? (
          <UserTypeMobile
            isProtected={isBPP}
            rebrandingMP={configs?.rebrandingMP}
            handleNextStep={handleNextStep}
          />
        ) : (
          <UserTypeDesktop
            isProtected={isBPP}
            rebrandingMP={configs?.rebrandingMP}
            handleNextStep={handleNextStep}
          />
        )}

        {hasBackToSellerAction && (
          <Button
            hierarchy="transparent"
            size="large"
            className="custom-button"
            onClick={() => handleRedirectingToStore()}
          >
            <IconBack />
            {translations.RETURN_TO(brand_name)}
          </Button>
        )}

        <section className="footer">
          <div className={isMobile ? 'centering-footer' : ''}>
            <Footer
              requiredMessage={translations.PROCESSED_BY_MERCADO_PAGO}
              requiredScreenReaderMessage={
                translations.SCREEN_READER_FOOTER_MESSAGE
              }
              deviceType={deviceType}
            />
          </div>
        </section>
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  flow: state.page.flow,
  configs: state.configurations,
});

const mapDispatchToProps = (dispatch) => ({
  stepAction: bindActionCreators(stepActions, dispatch),
});

module.exports = {
  ShippingUserTypeV2: connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ShippingUserTypeV2),
};
